import { JsonProperty, JsonObject } from 'typescript-json-serializer';
import { LmCurrent } from './lm-current.model';

@JsonObject()
export class LmStation {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('SubType') subtype: number;
  @JsonProperty('StartCurrent') startCurrent: number;
  @JsonProperty('MaxCurrent') maxCurrent: number;
  @JsonProperty('IsOffline') isOffline: boolean;
  @JsonProperty('IsCarConnected') isCarConnected: boolean;
  @JsonProperty('SelectedCurrent') selectedCurrent: number;
  @JsonProperty('MeasuredCurrent') measuredCurrent: LmCurrent;
}
